var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"passwordetail"},[_c('div',{staticClass:"passwordetail_title"},[_c('p',[_vm._v("收藏")])])])
}]

export { render, staticRenderFns }